const LightTheme = {
  mode: 'light',
  // Primary
  Bg1: '#FFFFFF',
  text1: '#16171A',
  svg1: '#5d5d5d',
  svg2: '#b4b4b4',
  border1: '#e6e6e6',
  modalBg1: '#fff',
  boxShadow1: 'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
  hoverBg1: '#EDEEEE',
  fieldBorder1: '#c4c4c4',
  fieldBorderHover1: '#828282',
  fieldText1: '#00000099',
  fieldDisable1: '#0000000a',
  lightGray: '#ededed',
  lightGrayHover: '#e5e5e5',
  lightBlue: '#f4faff',
  disableText1: '#989898',
  disableBg1: '#cacaca',
  red1: '#fc223b',
  tabBg1: '#f8f8f8',
  tabText1: '#758185',
  tab2: '#ffffffe6',

  gray: {
    1: '#757675',
  },
  colors: {
    2: '#333333',
    3: '#FFFFFF',
    4: '#2D90FF',
    5: '#DBDBDB',
  },
};

export default LightTheme;
